import { render } from "./PageList.vue?vue&type=template&id=62ba4338"
import script from "./PageList.vue?vue&type=script&lang=js"
export * from "./PageList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/PageList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62ba4338"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62ba4338', __exports__)) {
    api.reload('62ba4338', __exports__)
  }
  
  module.hot.accept("./PageList.vue?vue&type=template&id=62ba4338", () => {
    api.rerender('62ba4338', render)
  })

}


export default __exports__